import { WsStateTypes } from './modules/ws/types';
export enum PerspectiveEnum {
  // 侧视
  side,
  // 俯视
  overlook,
  free,
}
export default interface RootStateTypes {
  hideBottom: boolean;
  distanceMeasurement: {
    status: boolean;
    color: string;
    clear: boolean;
  };
  perspective: {
    type: PerspectiveEnum;
    t: number;
  };
  loadingText: string;
  mode?: 'connection' | 'PlayBack' | '';
  modelMapTree: any;
  modelMapTreeChecked: any;
  resources: string[];
  checkedEventTags: number[];
  varguardVisible: string[];
  mapLabelVisible:string,
  allEventTags:any,
  alarmCodeList:any[],
  checkedAlarmCodeList:any[],
  mapVersionMeta: any
}

export interface AllStateTypes extends RootStateTypes {
  wsModule: WsStateTypes;
}
